import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { IAppState } from '../../core/redux/IAppState';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { apiGetFaqs } from '../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { AppDocItem } from '../appDocItem';
import { assoc } from '../../language/module';


const KEY_ACTION = ACTION_TYPE.LOAD_FAQS_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.LOAD_FAQS_REQUEST,
  ACTION_TYPE.LOAD_FAQS_RESPONSE,
  ACTION_TYPE.LOAD_FAQS_ERROR,
];


export const loadFaqsAction = () => makeApiAction(
  {
    method:   'GET',
    endpoint: apiGetFaqs,
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS as RsaaTypes,
    bailout:  state => !!getLoading(state, KEY_ACTION, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<AppDocItem[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('faqs', payload, noLoadingOrError);
};


export const loadFaqsReducer = makeApiReducer<AppDocItem[]>(ACTIONS, KEY_ACTION, reducer);
